import $ from 'jquery';

import loadScript from 'chairisher/util/script';

import { getRecaptchaSiteKey, isEmailCreateRecaptchaEnabled } from 'chairisher/context/auth';
import { getRecaptchaJSUrl } from 'chairisher/context/script';
import { handleAsyncError } from 'chairisher/util/logging';

let loadingPromise;

/**
 * Loads google's recaptcha library.
 *
 * @return {Promise<object>}
 */
function loadRecaptcha() {
    if (!loadingPromise) {
        loadingPromise = loadScript({ scriptName: 'grecaptcha', scriptSrc: getRecaptchaJSUrl() });
    }

    return loadingPromise;
}

/**
 * Executes recaptcha v3: gets a unique token from google and returns a deferred with the token and action name as
 * data. It will also embed the token and action into the form if corresponding inputs exist
 * @param {string} actionName: a string to identify what action the user took
 * @returns {jQuery.Deferred}
 */
export default function executeRecaptcha(actionName) {
    const deferred = $.Deferred();
    const siteKey = getRecaptchaSiteKey();
    if (siteKey) {
        loadRecaptcha().then((recaptcha) => {
            recaptcha.ready(() => {
                recaptcha.execute(siteKey, { action: actionName }).then((token) => {
                    // embed token in form and send to backend to verify on form submission
                    let recaptchaData = {};
                    if (token) {
                        $('#id_recaptcha_token').val(token);
                        $('#id_recaptcha_action').val(actionName);
                        recaptchaData = {
                            recaptcha_action: actionName,
                            recaptcha_token: token,
                        };
                    }
                    deferred.resolve(recaptchaData);
                }, handleAsyncError);
            });
        }, handleAsyncError);
    } else {
        deferred.resolve();
    }
    return deferred;
}

/**
 * Runs reCAPTCHA and writes token/action into the given form.
 *
 * @param {HTMLElement|jQuery} formEl
 * @returns {Promise<object|undefined>}
 */
export async function executeRecaptchaForForm(formEl) {
    const $form = $(formEl);
    let recaptchaData;

    // TODO (CHAIR-19448): Remove this guard after rollout
    if (isEmailCreateRecaptchaEnabled()) {
        recaptchaData = await executeRecaptcha($form.find('[name=recaptcha_action]').val());

        if (recaptchaData?.recaptcha_token) {
            $form.find('[name=recaptcha_token]').val(recaptchaData.recaptcha_token);
            $form.find('[name=recaptcha_action]').val(recaptchaData.recaptcha_action);
        }
    }

    return recaptchaData;
}
